module.exports = __webpack_public_path__ + "static/media/terms-&-conditions.de9b5bb3.jpg";